import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RpcService } from '../../http/rpc.service';
import { Shift } from './models/shift';

@Injectable()
export class ShiftSettingsService {
  constructor(private rpc: RpcService) {}

  public getShifts(): Observable<Array<Shift>> {
    return this.rpc
      .makeManagerCall('getCompanyShifts')
      .pipe(map(this.mapShifts));
  }

  public deleteShift(payload: {
    shiftToDelete: Shift;
    shifts: Array<Shift>;
  }): Observable<any> {
    const shiftsToKeep: Array<Shift> = payload.shifts.filter(
      (shift: Shift) => shift.id !== payload.shiftToDelete.id
    );
    return this.updateShifts(shiftsToKeep);
  }

  public addShift(payload: {
    shiftToAdd: Shift;
    shifts: Array<Shift>;
  }): Observable<any> {
    const shifts: Array<Shift> = [...payload.shifts];
    const shift: any = Object.assign({}, payload.shiftToAdd);
    shifts.push(shift);
    return this.updateShifts(shifts);
  }

  public editShift(payload: {
    shiftToEdit: Shift;
    shifts: Array<Shift>;
  }): Observable<any> {
    const shiftsAdjusted: Array<Shift> = payload.shifts.map((shift: Shift) =>
      shift.id === payload.shiftToEdit.id ? payload.shiftToEdit : shift
    );
    return this.updateShifts(shiftsAdjusted);
  }

  private updateShifts(shifts: Array<Shift>): Observable<Array<Shift>> {
    return this.rpc
      .makeManagerCall('updateCompanySetting', [
        'shiftIntervalConfig',
        JSON.stringify({ shiftReports: shifts })
      ])
      .pipe(map(() => shifts));
  }

  private mapShifts(intervals: any): Array<Shift> {
    if (!intervals) {
      intervals = [];
    }
    return intervals
      .map(Shift.fromDto)
      .sort(
        (shift1: Shift, shift2: Shift) =>
          shift1.startTime.hour > shift2.startTime.hour
      );
  }
}
